import { useState } from 'react';
import { api, useAction } from '../../../api/hooks';
import { Button } from '../../../ui/Button';
import { ErrorAlert } from '../../../ui/feedback';
import { Field, Input, Select, Textarea } from '../../../ui/forms';
import { Modal } from '../../../ui/Modal';

export function AdminNoteDialog({
  kind,
  base,
  onClose,
  inv,
}: {
  kind: 'verify' | 'correct';
  base: string;
  onClose: () => void;
  inv: unknown[][];
}) {
  const [reason, setReason] = useState('');
  const [evidence, setEvidence] = useState('');
  const [corrected, setCorrected] = useState<'success' | 'failure' | 'unknown'>('failure');
  const m = useAction(
    () =>
      api.post(
        `${base}/${kind}`,
        kind === 'verify' ? { reason, evidence } : { reason, evidence, correctedOutcome: corrected },
      ),
    {
      success: kind === 'verify' ? 'Delivery verified' : 'Correction recorded',
      invalidate: inv as never,
      onSuccess: onClose,
    },
  );
  return (
    <Modal
      title={kind === 'verify' ? 'Verify reported delivery' : 'Record correction'}
      onClose={onClose}
      actions={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => m.mutate(undefined)}
            loading={m.isPending}
            disabled={!reason.trim() || !evidence.trim()}
          >
            Save
          </Button>
        </>
      }
    >
      <p className="muted">
        {kind === 'verify'
          ? 'Your verification is recorded separately; the original report stays visible.'
          : 'Corrections are appended; the original report is never overwritten. Delivered tickets are not reopened automatically.'}
      </p>
      {kind === 'correct' && (
        <Field label="Corrected outcome">
          {(p) => (
            <Select {...p} value={corrected} onChange={(e) => setCorrected(e.target.value as never)}>
              <option value="failure">Failure</option>
              <option value="unknown">Unknown</option>
              <option value="success">Success</option>
            </Select>
          )}
        </Field>
      )}
      <Field label="Evidence">
        {(p) => <Textarea {...p} rows={3} value={evidence} onChange={(e) => setEvidence(e.target.value)} />}
      </Field>
      <Field label="Reason">
        {(p) => <Input {...p} value={reason} onChange={(e) => setReason(e.target.value)} />}
      </Field>
      <ErrorAlert error={m.error} />
    </Modal>
  );
}
